import { createContext, useState } from "react";

export const AuthUserContext = createContext({});

export const AuthUserContextProvider = (props) => {
  const [authUser, setAuthUser] = useState(null);

  return (
    <AuthUserContext.Provider value={{ authUser, setAuthUser }}>
      {props.children}
    </AuthUserContext.Provider>
  );
};